// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__13Aoc","rootCenter":"LoadMoreObserver_rootCenter__3hk3W","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3sK7G"};